module.exports = __webpack_public_path__ + "static/img/hospitalizGuide05x.0343ab4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/aboutUs/hospitalizGuide05x.png
// module id = fldB
// module chunks = 1